// Признак оседания источника чтения редактора (`editor.draftSourceSettling`): после
// записи в живой курс без черновика зонд перечитывает `/moderation`, и до переезда
// редактора на появившийся черновик пакетные записи студии собирали бы тела блоков из
// живой версии. Единственное место, откуда признак читают все пакетные пути.
import { useAppSelector } from '@/store/hooks'

/** Сторож: признак снимается не позже этого срока, что бы ни случилось с переездом. */
export const DRAFT_SETTLE_MAX_MS = 20_000

export interface SettlingState {
  editor: { draftSourceSettling: number | null }
}

interface SettlingStore {
  getState: () => SettlingState
  subscribe: (listener: () => void) => () => void
}

export const selectIsDraftSourceSettling = (state: SettlingState, courseId: number): boolean =>
  state.editor.draftSourceSettling === courseId

export const useIsDraftSourceSettling = (courseId: number): boolean =>
  useAppSelector((state) => selectIsDraftSourceSettling(state, courseId))

/** Дождаться снятия признака у курса (сразу, если он не стоит). */
export const waitDraftSourceSettled = (store: SettlingStore, courseId: number): Promise<void> =>
  new Promise((resolve) => {
    if (!selectIsDraftSourceSettling(store.getState(), courseId)) {
      resolve()
      return
    }
    const unsubscribe = store.subscribe(() => {
      if (selectIsDraftSourceSettling(store.getState(), courseId)) return
      unsubscribe()
      resolve()
    })
  })

/** Исход одного перечитывания `/moderation` зондом. */
export type ProbeOutcome = 'failed' | 'no-draft' | 'draft'

/** Разбор результата `refetchCourseModeration` (результат RTK-запроса). */
export const probeOutcomeOf = (result: unknown): ProbeOutcome => {
  const r = result as { isError?: boolean; data?: { draftId?: number | null } } | undefined
  if (r === undefined || r === null || r.isError === true || r.data === undefined) return 'failed'
  return r.data.draftId === null || r.data.draftId === undefined ? 'no-draft' : 'draft'
}
